var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1754 7.78389C49.7391 1.89874 43.316 -1.23369 37.1777 0.443267L9.33398 8.03702C3.82852 9.55577 0 14.555 0 20.2503C0 98.5292 63.4711 162 141.75 162C147.445 162 152.445 158.172 153.963 152.666L161.557 124.823C163.234 118.684 160.102 112.261 154.216 109.825L123.841 97.1687C118.684 95.0171 112.704 96.5042 109.192 100.839L96.409 116.438C74.134 105.901 56.0988 87.8663 45.5625 65.5913L61.1613 52.8401C65.4961 49.2964 66.9832 43.348 64.8316 38.1905L52.1754 7.81553V7.78389Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMContact);
export default __webpack_public_path__ + "static/media/m-contact.e1dad6391a701f51b1209bc15505109e.svg";
export { ForwardRef as ReactComponent };